import { z } from 'zod';

import { Option } from '../../types/Option';

const terminalTypes = ['lug', 'screw'] as const;

type TerminalType = (typeof terminalTypes)[number];

const options = [
    { value: 'lug', label: 'Lug' },
    { value: 'screw', label: 'Screw terminal' },
] as Option<TerminalType>[];

const validator = z.enum(terminalTypes).nullable().default(null);

export const TerminalType = {
    validator,
    options,
};
